import validator from "validator";
import message from "../../../../messages/advertise/banner";

const validateAddress = (address) => {
  if (validator.isEmpty(address)) {
    return message.ADDRESS_DOSE_NOT_EXIST;
  }

  if (!address.trim().length) {
    return message.ADDRESS_DOSE_NOT_EXIST;
  }

  return true;
};

const validateFormAddAdvertiseBanner = (info) => {
  const resValidateAddress = validateAddress(info.address);
  if (resValidateAddress != true) {
    return resValidateAddress;
  }

  return true;
};

export default validateFormAddAdvertiseBanner;
